import { Box, CircularProgress, Divider, Grid2 } from '@mui/material';
import { calculateCreatedAgo, printEventDates } from '../../../components/commonFunc';
import { HubPagination } from './HubPagination';
import { ListingCardImage } from './ListingCardImage';
import { HubListingCardLink } from './HubListingCardLink';

export function HubListingView({
  title,
  firstItem,
  renderFeatured,
  pageItems,
  loading,
  totalPages,
  currentPage,
  onPageChange,
}) {
  return (
    <Box className="w-full text-start">
      <h4 className="my-4 text-2xl font-medium leading-tight sm:text-3xl sm:leading-snug md:text-[42px] md:leading-[54.6px]">
        {title}
      </h4>
      <Box className="w-full my-4">
        {firstItem && renderFeatured ? renderFeatured(firstItem) : null}
      </Box>
      {loading ? (
        <Box className="w-full flex justify-center items-center min-h-[220px] py-4">
          <CircularProgress />
        </Box>
      ) : (
        <Box className="w-full py-4">
          <Grid2 container spacing={2}>
            {pageItems.map((itemData, key) => (
              <Grid2
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                key={`${itemData.postId ?? key}-${key}`}
                size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}
                marginTop={2}
              >
                <HubListingCardLink item={itemData}>
                  <Box className="w-full">
                    <div className="cursor-pointer w-full aspect-[300/200] rounded-2xl blog-card overflow-hidden">
                      <ListingCardImage
                        mediaPath={itemData.postMedia}
                        title={itemData.title}
                        postType={itemData.postType}
                        alt={itemData.title}
                        showFallbackTitle={false}
                      />
                    </div>
                    <h6 className="cursor-pointer line-clamp-2 text-[24px] leading-[32px] font-medium my-3 transition-colors duration-300 group-hover:text-[#0099B0]">
                      {itemData.title}
                    </h6>
                  </Box>
                  {itemData.postType !== 'Events' ? (
                    <Box
                      className="cursor-pointer w-full mt-4 text-[#949494] text-[12px] leading-[21px]"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      gap={4}
                    >
                      <span>{calculateCreatedAgo(itemData)}</span>
                      <span>By Charlee.ai</span>
                    </Box>
                  ) : (
                    <Box
                      className="cursor-pointer w-full mt-4 text-[#949494] text-[12px] leading-[21px]"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      gap={4}
                    >
                      <span>{printEventDates(itemData)}</span>
                    </Box>
                  )}
                </HubListingCardLink>
              </Grid2>
            ))}
          </Grid2>
        </Box>
      )}
      <Divider className="border-gray-200" />
      <Box className="w-full py-6 md:py-8">
        <HubPagination
          count={totalPages}
          page={currentPage}
          onChange={onPageChange}
        />
      </Box>
    </Box>
  );
}
